<template>
  <div class="sum-list-box">
    <div class="tit-sup-box">
      <h4>工程名稱：{{ itemName }}</h4>
    </div>
    <ul class="list list-tit sum-list">
      <li class="title">
        <div>員工</div>
        <div>尺寸</div>
        <!-- <div>顏色</div> -->
        <div>完成件數</div>
      </li>
    </ul>
    <ul class="list sum-list">
      <MemSumItem
        v-for="(item, index) in memList"
        :key="index"
        :name="item.employee_name"
        :size="item.order_size"
        :done="item.count"
      />
    </ul>
  </div>
</template>
<script>
import MemSumItem from "@/components/MemSumItem.vue";
export default {
  name: "SumItem",
  props: ["itemName", "memList"],
  data() {
    return {};
  },
  components: {
    MemSumItem,
  },
};
</script>